export default __webpack_public_path__ + "static/media/ic-test.0ae857ec.svg";